export const CALENDAR_SLOTS = 'fo/calendar/slots'
export const CALENDAR_SLOT = 'fo/calendar/editSlot'
export const BLOCK_SLOT = 'fo/calendar/blockSlot'
export const FREE_SLOT = 'fo/calendar/freeSlot'
export const SET_REFERENCE_DATE = 'fo/calendar/setReferenceDate'
export const RESET_REFERENCE_DATE = 'fo/calendar/resetReferenceDate'
export const DELETE_SLOT = 'fo/calendar/deleteSlot'
